import React from 'react';

interface ICircularProgressBarProps {
	size?: number;
	stroke?: number;
	step?: number;
	className?: string;
	withBackgroundRing?: boolean;
}

export const CircularProgressBar = ({
	size = 52,
	stroke = 4,
	step = 0,
	withBackgroundRing = false,
	className,
}: ICircularProgressBarProps) => {
	const radius = size / 2 - stroke;
	const circumference = radius * 2 * Math.PI;

	return (
		<svg className={`${className}`} width={size} height={size}>
			{withBackgroundRing && (
				<circle
					className="transition-all duration-200 origin-[50%_50%] stroke-gray-400"
					strokeDasharray="0"
					strokeWidth={stroke}
					fill="transparent"
					r={radius}
					cx={size / 2}
					cy={size / 2}
				/>
			)}
			<circle
				className="transition-all duration-200 -rotate-90 origin-[50%_50%]"
				strokeDasharray={`${Math.round(circumference) * step} ${Math.round(circumference)}`}
				stroke="#ffcc00"
				strokeWidth={stroke}
				fill="transparent"
				r={radius}
				cx={size / 2}
				cy={size / 2}
			/>
		</svg>
	);
};
